var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "autocomplete" }, [
    _c("div", { staticClass: "search-bar" }, [
      _c(
        "div",
        {
          staticClass:
            "absolute left-2.5 top-1.5 flex items-center h-8 search-icon customIcon",
        },
        [
          _c(
            "svg",
            {
              attrs: {
                "data-v-843a99a0": "",
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  "data-v-843a99a0": "",
                  d: "M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z",
                  stroke: "#717986",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _c("path", {
                attrs: {
                  "data-v-843a99a0": "",
                  d: "M14.0001 13.9996L11.1001 11.0996",
                  stroke: "#717986",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
        ]
      ),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.query,
            expression: "query",
          },
        ],
        staticClass:
          "placeholder-italic form-input flex-1 block rounded-md sm:text-sm sm:leading-5 focus:shadow-none outline-none focus:outline-none focus:border-primary h-input customFormInput pl-8 focus:border-primary rounded-md",
        attrs: { type: "search", placeholder: _vm.placeholder },
        domProps: { value: _vm.query },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.query = $event.target.value
            },
            _vm.handleInput,
          ],
          blur: _vm.hideSuggestions,
        },
      }),
      _vm.showSuggestions && !_vm.noResultFound
        ? _c(
            "ul",
            { staticClass: "autocomplete-suggestions" },
            _vm._l(_vm.uniqueSuggestions, function (suggestion, index) {
              return _c(
                "li",
                {
                  key: index,
                  on: {
                    mousedown: function ($event) {
                      $event.preventDefault()
                      return _vm.selectSuggestion(suggestion)
                    },
                  },
                },
                [
                  suggestion.matchField === "name"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("Name:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue)),
                        ]),
                      ]
                    : _vm._e(),
                  suggestion.matchField === "job_title"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("Job Title:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue)),
                        ]),
                      ]
                    : _vm._e(),
                  suggestion.matchField === "experience"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("Experience:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue)),
                        ]),
                      ]
                    : _vm._e(),
                  suggestion.matchField === "education"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("Education:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue)),
                        ]),
                      ]
                    : _vm._e(),
                  suggestion.matchField === "skill"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("Skills:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue)),
                        ]),
                      ]
                    : _vm._e(),
                  suggestion.matchField === "language"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("Language:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue)),
                        ]),
                      ]
                    : _vm._e(),
                  suggestion.matchField === "country"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("Country:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue)),
                        ]),
                      ]
                    : _vm._e(),
                  suggestion.matchField === "city"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("City:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue)),
                        ]),
                      ]
                    : _vm._e(),
                  suggestion.matchField === "region"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("Region:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue)),
                        ]),
                      ]
                    : _vm._e(),
                  suggestion.matchField === "min rate"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("Min Rate:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue)),
                        ]),
                      ]
                    : _vm._e(),
                  suggestion.matchField === "max rate"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("Max Rate:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue)),
                        ]),
                      ]
                    : _vm._e(),
                  suggestion.matchField === "industries"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("Industries:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue)),
                        ]),
                      ]
                    : _vm._e(),
                  suggestion.matchField === "familyname"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("Last name:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue)),
                        ]),
                      ]
                    : _vm._e(),
                  suggestion.matchField === "givenname"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("First name:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue)),
                        ]),
                      ]
                    : _vm._e(),
                  suggestion.matchField === "certification"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("Certification:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue) + " "),
                        ]),
                      ]
                    : _vm._e(),
                  suggestion.matchField === "tag"
                    ? [
                        _c("div", [
                          _c("strong", [_vm._v("Tag:")]),
                          _vm._v(" " + _vm._s(suggestion.matchValue)),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              )
            }),
            0
          )
        : _vm._e(),
      !_vm.showSuggestions && _vm.noResultFound
        ? _c("ul", { staticClass: "autocomplete-suggestions" }, [_vm._m(0)])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("li", [_c("p", [_vm._v("Nothing matches the query")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }